module.exports = __webpack_public_path__ + "img/cooperation_bg_hezuoliucheng@.63c53dcb.png";